import { fetchPosService } from "../fetchPosService";
import type {
  CartRemoveItemMutation,
  CartRemoveItemMutationVariables,
  PosCartRemoveItemInput,
} from "../generates";
import { CartRemoveItemDocument } from "../types";

export type RemoveCartItemProps = {
  input: PosCartRemoveItemInput;
  storeCode?: string;
};

export const removeCartItem = async ({
  input,
  storeCode,
}: RemoveCartItemProps): Promise<CartRemoveItemMutation> => {
  return fetchPosService<
    CartRemoveItemMutation,
    CartRemoveItemMutationVariables
  >({
    query: CartRemoveItemDocument,
    variables: {
      input,
    },
    store: storeCode,
  });
};
